import Vue from 'vue'
import Vuex from 'vuex'
import service from '@/data/service.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,

    term: '',
    orderBy: '_score',
    orderByAsc: 'desc',
    showProtected: false,

    data: [],
    page: 0,
    pageSize: 10,
    resultCount: 0,

    adv: {
      searchBy: 'title',
      filters: []
    }
  },
  getters: {
    atMinPage: state => state.page <= 0,
    atMaxPage: state => state.page >= Math.ceil(state.resultCount / state.pageSize) - 1,
    maxPage: state => Math.ceil(state.resultCount / state.pageSize) - 1
  },
  mutations: {
    initSimple(state) {
      if(state.adv) {
        state.adv = null
        state.data = []
      }
    },
    initAdv(state) {
      if(!state.adv) {
        state.adv = {
          searchBy: 'title',
          filters: []
        }
        state.data = []
      }
    },
    set(state, {term, orderBy, orderByAsc, showProtected, adv}) {
      if(term !== undefined) state.term = term
      if(orderBy !== undefined) state.orderBy = orderBy
      if(orderByAsc !== undefined) state.orderByAsc = orderByAsc
      if(showProtected !== undefined) state.showProtected = showProtected
      if(adv !== undefined) state.adv = adv
    },
    async search(state) {
      state.loading = true
      state.page = 0
      state.resultCount = await count(state)
      state.data = await search(state)
      state.loading = false
    },
    async nextPage(state) {
      state.loading = true
      state.page += 1
      state.data = await search(state)
      state.loading = false
    },
    async prevPage(state) {
      state.loading = true
      state.page -= 1
      state.data = await search(state)
      state.loading = false
    }
  }
})

const toQuery = state => {
  if(!state.adv) {
    if(state.term == "")
      return {
        "bool": {
          "must": {
            "match_all": {}
          },
          "filter": {match:{visibility:state.showProtected ? 'protected' : 'public'}}
        }
      }
    else
      return {
        "bool": {
          "must": {
            "multi_match": {
              "query": state.term,
              "fields": [
                "title",
                "description"
              ],
              "type": "most_fields",
              "fuzziness": "AUTO"
            }
          },
          "should": {
            "multi_match": {
              "query": state.term,
              "fields": [
                "title",
                "description"
              ],
              "type": "most_fields"
            }
          },
          "filter": {match:{visibility:state.showProtected ? 'protected' : 'public'}}
        }
      }
  } else {
    let processedFilters = state.adv.filters.reduce((acc, filter) => {
      if(['publishDate', 's3_details.LastModified'].includes(filter.filterBy)) {
        let inner = filter.altType ? {gt: filter.input + ' 00:00:00'} : {lt: filter.input + ' 00:00:00'}
        if(filter.filterBy == 'publishDate')
          acc.filter.push({range: {publish_date: inner}})
        else if(filter.filterBy == 's3_details.LastModified')
          acc.filter.push({range: {last_update: inner}})
      }
      return acc
    }, {filter: [], mustNot: [ {term: {visibility: "private"}} ]})
    if(!state.showProtected)
      processedFilters.mustNot.push({term:{visibility:"protected"}})
    else
      processedFilters.mustNot.push({term:{visibility:"public"}})
    let query = {
      "bool": {
        "must": {
          "term": {}
        },
        "filter": processedFilters.filter,
        "must_not": processedFilters.mustNot
      }
    }
    query.bool.must.term[state.adv.searchBy] = state.term
    console.log(JSON.stringify(query,null,2))
    return query
  }
}

const search = state => {
  let body = {
    query: toQuery(state),
    from: state.page * state.pageSize,
    size: state.pageSize,
    sort: [{[state.orderBy]: state.orderByAsc}]
  }
  try{
  return service.searchDatasets(body)
  } catch(err) {
    console.log(err)
  }
}

const count = state => {
  return service.countDatasets({
    query: toQuery(state)
  })
}